// hbars.js — waagerechte Balken (Verteilungen: Rollen, Länder, Status, Umsatzquellen).
// Zahl steht immer daneben, der Balken ist nur Lesehilfe (aria-hidden) — die Liste ist die Datenquelle für Screenreader.
import { html, attrs } from '../core/h.js';

/** Anteil je Eintrag: bezogen auf den größten Wert (`max`) oder auf die Summe (`total`). Ohne Werte 0. */
export function hbarRatios(values, base = 'max') {
  const v = values.map((x) => Math.max(0, Number(x) || 0));
  const ref = base === 'total' ? v.reduce((s, x) => s + x, 0) : Math.max(0, ...v);
  return v.map((x) => (ref > 0 ? x / ref : 0));
}

/** items: [{ label, value, display?, tone?: 'primary'|'secondary'|'tertiary'|'outline'|'error' }] */
export function hbars(items, { label = '', base = 'max', fmt = (v) => String(v) } = {}) {
  const r = hbarRatios(items.map((i) => i.value), base);
  return html`<ul class="vc-hbars"${attrs({ 'aria-label': label || null })}>${items.map((it, i) => html`<li>
    <span class="vc-hbar-label">${it.label || '–'}</span>
    <span class="vc-hbar${it.tone ? ' is-' + it.tone : ''}" aria-hidden="true"><span style="--w:${r[i].toFixed(3)}"></span></span>
    <span class="vc-hbar-n">${it.display != null ? it.display : fmt(it.value)}</span></li>`)}</ul>`;
}
